import React, { MouseEvent, useMemo } from 'react';
import { useSidePanelSearch } from 'shared/components/SidePanel/components/SearchPanel/state/providers/SearchPanelProvider';
import { useResolutionProvider } from 'shared/providers/ResolutionProvider';
import { useHistory } from 'react-router-dom';
import { RouteBasePaths } from 'routes';
import { StyledAvatar, StyledAvatarType } from '@televet/kibble-ui/build/patterns/StyledAvatar';

interface ChannelAvatarProps {
  clinicPetParentId: string;
  displayName: string;
  isInboundSms: boolean;
  isTest: boolean;
  onClick?: (e: MouseEvent) => void;
}

const getAvatarType = ({
  isTestClient,
  isInboundSms,
}: {
  isTestClient: boolean;
  isInboundSms: boolean;
}): StyledAvatarType => {
  if (isTestClient) {
    return 'Client';
  }

  if (isInboundSms) {
    return 'SMS';
  }

  return 'Client';
};

const ChannelAvatar = ({
  clinicPetParentId,
  displayName,
  isInboundSms,
  isTest,
  onClick,
}: ChannelAvatarProps): JSX.Element => {
  const { viewClinicPetParent, setCurrentClinicPetId, currentClinicPetParentId } = useSidePanelSearch();
  const { isMobile } = useResolutionProvider();
  const history = useHistory();

  const avatarType = useMemo(() => getAvatarType({ isTestClient: !!isTest, isInboundSms }), [isTest, isInboundSms]);

  return (
    <StyledAvatar
      name={displayName}
      type={avatarType}
      handleClick={(e: MouseEvent): void => {
        if (onClick) {
          onClick(e);
        }

        // only clear pet id when changing pet parent
        if (currentClinicPetParentId !== clinicPetParentId) {
          setCurrentClinicPetId('');
        }
        e.stopPropagation();
        viewClinicPetParent({ clinicPetParentId: clinicPetParentId || '' });
        if (isMobile) {
          history.push(RouteBasePaths.Conversations);
        }
      }}
    />
  );
};

export default ChannelAvatar;
